import "./invitation.css";
import "./animation.css"
import IntroSection from "./IntroSection";
import InvitationInfoSection from "./InvitationInfoSection";
import FormSection from "./FormSection";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import API from "API";
import dayjs from "dayjs";
import ParrentIntroSection from "./ParrentIntroSection";
import ThankYouSection from "./ThankYouSection";
import WeddingComingSection from "./WeddingComingSection";
import { preloadFonts, preloadImages } from "general_function";
import WeddingAlbumSection from "./WeddingAlbumSection";
import CountdownSection from "./CountdownSection";
import TimeLineSection from "./TimeLineSection";

// const mockData = {
//     "invitation": {
//         "id": 2,
//         "place": {
//             "id": 1,
//             "tab": "saigon",
//             "display": "Lễ Thành Hôn",
//             "name_place": "RiverSide Palace",
//             "map": "https://maps.app.goo.gl/2pkhX9QFXmzErEcT7",
//             "address": "360D Bến Vân Đồn, Phường Vĩnh Hội, TP. Hồ Chí Minh",
//             "open_time": dayjs("2026-06-11T18:00:00"),
//             "ritual_time": dayjs("2026-06-11T18:30:00"),
//             "party_time": dayjs("2026-06-11T19:30:00")
//         },
//         "url_code": "bosch_anh_nam",
//         "data": {
//             "name": "Anh Nam",
//             "group": "Bosch",
//             "family": 0,
//             "displayname": "Anh Nam",
//             "self_pronoun": "chúng em",
//             "customer_address_term": "anh"
//         },
//         "confirm_join": 0
//     },
//     "places": [
//         {
//             "id": 1,
//             "tab": "saigon",
//             "display": "Lễ Thành Hôn",
//             "name_place": "RiverSide Palace",
//             "map": "https://maps.app.goo.gl/2pkhX9QFXmzErEcT7",
//             "address": "360D Bến Vân Đồn, Phường Vĩnh Hội, TP. Hồ Chí Minh",
//             "open_time": dayjs("2026-06-11T18:00:00"),
//             "ritual_time": dayjs("2026-06-11T18:30:00"),
//             "party_time": dayjs("2026-06-11T19:30:00")
//         },
//         {
//             "id": 2,
//             "tab": "hanoi",
//             "display": "Lễ Vu Quy",
//             "name_place": "Nhà Hàng Minh Trí",
//             "map": "https://maps.app.goo.gl/W8wYjL19nJGKY2mw9",
//             "address": "Mặt đường Nguyễn Viết Thứ - Thôn Phương Bảng 1 - Xã Sơn Đồng",
//             "open_time": dayjs("2026-05-20T12:30:00"),
//             "ritual_time": dayjs("2026-05-20T13:30:00"),
//             "party_time": dayjs("2026-05-20T14:00:00")
//         }
//     ]
// }

const preloadImagesArr = [
    "/img/intro-cdcr-r.jpg",
    '/img/wedding_coming.jpg',
    "/img/yellowish-paper-texture-bg.png",
]

const preloadFontsArr = [
    "Lexend",
    "Gowun Dodum",
    "Birthstone",
    "Cormorant Garamond",
    "Noto Serif",
    "EB Garamond",
    "Crimson Text",
    "Dancing Script",
]

export default function Home() {
    const { place, code } = useParams();
    const [ready, setReady] = useState(false);
    const [invitation, setInvitation] = useState(null);
    const [places, setPlaces] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (ready && window.location.hash) {
            setTimeout(() => {
                const id = window.location.hash.replace("#", "");
                function findElement() {
                    const el = document.getElementById(id);
                    if (el) {
                        el.scrollIntoView({ behavior: "smooth" });
                        return;
                    }
                    setTimeout(findElement, 200);
                }
                findElement();
            }, 1000);
        }
    }, [ready]);

    useEffect(() => {
        async function loadAssets() {
            await Promise.all([
                preloadImages(preloadImagesArr),
                preloadFonts(preloadFontsArr),
            ]);

            setReady(true);
        }
        loadAssets();
    }, []);

    useEffect(() => {
        if (place && code) {
            API.get("invitation/", {
                params: {
                    q: code, p: place
                }
            })
                .then(res => {
                    res.data.invitation.place.open_time = dayjs(res.data.invitation.place.open_time);
                    res.data.invitation.place.ritual_time = dayjs(res.data.invitation.place.ritual_time);
                    res.data.invitation.place.party_time = dayjs(res.data.invitation.place.party_time);
                    setInvitation(res.data.invitation);
                    setPlaces(res.data.places.map(
                        item => ({
                            ...item,
                            open_time: dayjs(item.open_time),
                            ritual_time: dayjs(item.ritual_time),
                            party_time: dayjs(item.party_time)
                        })
                    ));
                })
                .catch(({ response }) => {
                    if (response.status === 404) {
                        navigate("/");
                    }
                })
        } else {
            API.get("places/")
                .then(res => {
                    setPlaces(res.data.map(
                        item => ({
                            ...item,
                            open_time: dayjs(item.open_time),
                            ritual_time: dayjs(item.ritual_time),
                            party_time: dayjs(item.party_time)
                        })
                    ));
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    }, [place, code, navigate])

    return ((!invitation && !places) || !ready) ? <></> : <>
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            
            backgroundColor: "#f3ede0",
            backgroundRepeat: "repeat",
            zIndex: 3,
        }}>
            {/* <FallingFlower /> */}
        </div>
        <div className="content" style={{
            margin: "auto",
            backgroundImage: "url('/img/yellowish-paper-texture-bg.png')",
            backgroundRepeat: "repeat",
            position: "relative",
            zIndex: 5,
        }}>
            {/* <FallingFlower /> */}
            <IntroSection invitation={invitation} places={places} />
            <ParrentIntroSection invitation={invitation} />
            {!invitation || (invitation.data.both_tab === 1) ? <>
                <InvitationInfoSection type="hanoi" weddingInfo={places} />
                <InvitationInfoSection type="saigon" weddingInfo={places} />
            </> : <InvitationInfoSection place={invitation.place} invitation={invitation}/>}
            <FormSection invitation={invitation} />
            {/* <TimeLineSection /> */}
            <ThankYouSection invitation={invitation}/>
            <WeddingAlbumSection />
            <CountdownSection weddingInfo={invitation?.place || places[0]}/>
            <WeddingComingSection />
            {/* <ThatMomentSection /> */}
        </div>
    </>
}